"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_FILE_EXTENSIONS_FROM_USER_DOMAIN = void 0;
exports.ALLOWED_FILE_EXTENSIONS_FROM_USER_DOMAIN = [
    'pdf',
    'docx',
    'zip',
    'pptx',
    'xlsx',
    'doc',
    'txt',
    'rar',
    'xls',
    'ppt',
    'ppsx',
    'epub',
    'rtf',
    'pub',
    'csv',
];
//# sourceMappingURL=constants.js.map